import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router, RouterLink, RouterModule } from '@angular/router';
import { CommonModule, DatePipe } from '@angular/common';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { Urls } from 'src/app/lib/urls';
import { RequestsService } from 'src/app/core/services/http/requests.service';
import { DialogService } from 'src/app/core/services/dialog.service';
import { UserService } from 'src/app/core/services/user.service'; // adjust path if needed
import { AuthService } from 'src/app/core/services/auth.service';
import { IdleWatcherService } from 'src/app/services/idle-watcher.service';
import { UserStatusCheckerService } from 'src/app/services/user-status-checker.service';
import { SharedDirectivesModule } from 'src/app/shared/modules/shared-directives.module';
import { RbacService } from 'src/app/services/rbac.service';

@Component({
  selector: 'app-sidenav',
  templateUrl: './sidenav.component.html',
  styleUrls: ['./sidenav.component.scss'],
  imports: [RouterLink, CommonModule, RouterModule, SharedDirectivesModule],
  standalone: true,
})
export class SidenavComponent implements OnInit, OnDestroy {
  private destroy$ = new Subject<void>();

  currentUser = [];
  firstName:   string | null = null;
  lastName:    string | null = null;
  accountType: string | null = null;
  loginTime:   string | null = null;
  show_dropdown = false;

  constructor(
    private route: Router,
    private request: RequestsService,
    private dialogService: DialogService,
    private datePipe: DatePipe,
    private userService: UserService,
    private authService: AuthService,
    private idleWatcher: IdleWatcherService,
    private userStatusChecker: UserStatusCheckerService,
    private rbacService: RbacService,
  ) {}

  ngOnInit(): void {
    if (this.route.url === '/features/announcement') {
      localStorage.setItem('navigate', '3');
    }

    this.loadFromStorage();

    this.userService.onProfileUpdated$
      .pipe(takeUntil(this.destroy$))
      .subscribe(() => this.loadFromStorage());
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  private loadFromStorage(): void {
    this.firstName   = localStorage.getItem('firstName');
    this.lastName    = localStorage.getItem('lastName');
    this.accountType = localStorage.getItem('accountType'); 
    this.loginTime   = localStorage.getItem('loginTime');
  }

  showDropdown(bool: boolean): void {
    if (bool) {
      this.show_dropdown = !this.show_dropdown;
    } else {
      setTimeout(() => {
        this.show_dropdown = false;
      }, 300);
    }
  }

  logout(): void {
    this.idleWatcher.stop();
    this.userStatusChecker.stopPolling();
    this.authService.clearSession();
    this.rbacService.reset(); 
    this.route.navigate(['/login']);
    this.request.get(Urls.logout + '/').catch(() => {
    });
  }

  setheader(index: number): void {
    localStorage.setItem('navigate', index.toString());
  }

  lastLogin(): void {
    const formattedLoginTime = this.datePipe.transform(this.loginTime, 'yyyy-dd-MM hh:mm:ss');
    this.dialogService.openConfirmDialog('intererpelorts.megapay.ph says', formattedLoginTime!, true);
  }

  get isCashActive(): boolean {
    return this.route.url.includes('cash-in-tranaction-logs') || 
          this.route.url.includes('cash-out-tranaction');
  }

}
